import { render, staticRenderFns } from "./KitOnboarding.vue?vue&type=template&id=231385e3&lang=pug"
import script from "./KitOnboarding.vue?vue&type=script&lang=js"
export * from "./KitOnboarding.vue?vue&type=script&lang=js"
import style0 from "./KitOnboarding.vue?vue&type=style&index=0&id=231385e3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports